<article>
    <ng-container [ngTemplateOutlet]="content"></ng-container>
    <div class="d-flex align-items-center mt-4" [ngClass]="{'justify-content-start': distanceStartControlsIndicators, 'justify-content-end': distanceEndControlsIndicators, 'justify-content-between': distanceBetweenControlsIndicators, 'justify-content-center': distanceCenterControlsIndicators}" *ngIf="showControls || showIndicators">
        <div *ngIf="showControls && carouselResize.items.length > 1">
            <ng-container *ngFor="let indicator of carouselResize.items; track i; let i = index">
                <span (click)="indicatorSlide(i)" class="indicator" [ngClass]="{'active': carouselResize.currentIndex === i}"></span>
            </ng-container>
        </div>
        <div class="indicators-carousel" *ngIf="showIndicators && carouselResize.items.length > 1">
            <i (click)="previousSlide()" id="nextBtn" class="fa-solid fa-arrow-right"></i>
            <i (click)="nextSlide()" id="prevBtn" class="fa-solid fa-arrow-left"></i>
        </div>
    </div>
</article>